import React from "react";
import "./styles.scss";
import { FormCheck, FormCheckUpdated } from "..";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`checkBox-wrapper ${
          data.isActive ? "active-me" : ""
        } d-flex align-items-center`}
        onClick={onClick}
      >
        <FormCheck
          data={{ iconName: "check", isSelect: data.isActive ? true : false }}
        />

        <div className={"cw__checkName d-flex align-items-center"}>
          {data.checkName}
        </div>
      </div>
    </>
  );

  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
